import styled from "styled-components"

import { spacing, IconSimpleArrowRightMedium, borderRadius, colors } from "@izettle/otto"
import { Text, SvgIcon, ButtonStyledLink } from "@izettle/react"

import { baseUrl } from "@/constants"
import { IconMedium } from "@/models"
import { theme } from "@/theme"

const StyledLinkItem = styled(ButtonStyledLink)`
&& {
  border-radius : ${borderRadius.medium} !important;
  border-color: ${colors.border.form};
  margin-top: ${spacing.xxSmall};
  margin-bottom: ${spacing.none};
  padding-top: ${spacing.small};
  padding-bottom: ${spacing.small};

  &:hover {
    border-color: ${colors.border.focus};
  }

  &:active {
    border-color: ${colors.background.inverted} !important;
  }
}
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${theme.devices.tinyMobile} {
    margin-right: ${spacing.xxSmall};
  }

  @media ${theme.devices.mobile} {
    margin: ${spacing.none} ${spacing.small};
  }
`

const ItemTitle = styled(Text.Regular)`
  padding: ${spacing.none};
  margin: ${spacing.none};
`

const ItemText = styled(Text.SmallSecondary)`
  padding: ${spacing.none};
  margin: ${spacing.none};
`

const StyledIcon = styled(SvgIcon)`
  @media ${theme.devices.tinyMobile} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: inline;
  }
`

type ToDoItemProps = {
  documentType: string
  icon: IconMedium
  name: string
  description: string
  paypalTheme?: boolean
}

export const ToDoItem: React.FC<ToDoItemProps> = ({
  documentType,
  icon,
  name,
  description,
  paypalTheme,
}) => {
  return (
    <StyledLinkItem to={`${baseUrl}/${documentType}`} variant="secondary" size="small">
      <StyledIcon color={paypalTheme ? "default" : "action"} icon={icon} />
      <TextWrapper>
        <ItemTitle>{name}</ItemTitle>
        <ItemText>{description}</ItemText>
      </TextWrapper>
      <SvgIcon color={paypalTheme ? "secondary" : "action"} icon={IconSimpleArrowRightMedium} />
    </StyledLinkItem>
  )
}
